import { useBeforeUnload } from 'react-router-dom';
import { useCallback } from 'react';

export const usePrompt = (preventDefault) => {
    useBeforeUnload(
        useCallback(
            (event) => {
                if (preventDefault) {
                    event.preventDefault();
                    event.returnValue = 'message';
                }
            },
            [preventDefault]
        )
    );
};
